module.exports = __webpack_public_path__ + "static/media/2.ffc15539.jpg";